import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor() {
    // This is intentional
  }

  /**
   * Filters results by matching search string with substring of the given properties
   * If no results, continues searching on partial match properties, splitting by space
   * @param searchValue - The search value
   * @param sourceArray - The source array
   * @param propertyList - The property list
   * @param partialMatchProperties - The properties to use for partial matching
   */
  filterResults(searchValue: string, sourceArray: any[], propertyList: string[], partialMatchProperties?: string[]) {
    searchValue = searchValue.toLowerCase();
    searchValue = searchValue.trim();

    const searchParts = searchValue.split(' ').filter(part => part.length !== 0);

    if (!sourceArray || !sourceArray.length) {
      return;
    }

    const sourceList = sourceArray.slice(); // clone list
    let destList = [];

    if (!searchParts.length) {
      return destList;
    }

    destList = this.getPotentialResults(sourceList, propertyList, searchValue);

    // if we found at least one result (or we don't want partial match), return the results
    // if not, we continue searching with partial matching
    if (destList.length || !partialMatchProperties || !partialMatchProperties.length) {
      return destList;
    }

    this.getPartialResults(partialMatchProperties, sourceList, searchParts, destList);

    return destList;
  }

  private getPotentialResults(sourceList, propertyList, searchValue) {
    let idx = 0;
    const destList = [];
    while (idx < sourceList.length) {
      const potentialResult = sourceList[idx];

      // if the result has any property that contains the search string
      let found = false;
      propertyList.forEach(prop => {
        if (!found && potentialResult[prop] !== null && potentialResult[prop].toLowerCase().indexOf(searchValue) !== -1) {
          found = true;
          // add the result to the filtered list and remove from source list
          destList.push(potentialResult);
          sourceList.splice(idx, 1);
        }
      });

      if (!found) {
        idx++;
      }
    }
    return destList;
  }

  private getPartialResults(partialMatchProperties, sourceList, searchParts, destList) {
    // search for each partial match property
    partialMatchProperties.forEach(prop => {
      let idx = 0;
      while (idx < sourceList.length) {
        const customer = sourceList[idx];

        const propertyParts = customer[prop] !== null ? customer[prop].toLowerCase().split(' ') : [];
        let found = false;
        searchParts.forEach(part => {
          if (!found && propertyParts.indexOf(part) !== -1) {
            found = true;
            // add the customer to the filtered list and remove from source list
            destList.push(customer);
            sourceList.splice(idx, 1);
          }
        });
        if (!found) {
          idx++;
        }
      }
    });
  }
}
